import {Directive, HostBinding, Input, OnInit, ViewContainerRef,} from '@angular/core';

export type ValgButtonType =  | 'primary'
    | 'secondary'
    | 'function'
    | 'nav-outline'
    | 'nav-solid'
    | 'accept'
    | 'text-only'
    | 'text-only-without-padding'
    | 'text-only-border'
    | 'icon'
    | 'tertiary-icon-right'
    | 'icon-no-highlight'
    | 'small'
    | undefined;

@Directive({
  selector: 'button[valgButton], a[valgButton]',
})
export class ValgButtonDirective implements OnInit {
  @Input() color: ValgButtonType

  @HostBinding('class')
  elementClass = 'valg-button';
  private readonly _host: HTMLButtonElement;

  constructor(protected viewContainerRef: ViewContainerRef) {
    this._host = viewContainerRef.element.nativeElement;
  }

  ngOnInit(): void {
    if (this.color) {
      this._host.classList.add(`${this.elementClass}__${this.color}`);
    }
  }
}
